import Vue from 'vue'
import Vuex from 'vuex'
import { ToolButtonType } from '@/js/common.js'
import { SetCenterViewUrl } from "@/js/CommonFunc.js";
import acryPrint from './modules/acryPrint'
import firstTimeFree from './modules/firstTimeFree'
import behalfCreate from './modules/behalfCreate'
import designPreview from './modules/designPreview'

Vue.use(Vuex)

const initialState = () => ({
  // マネージャー関連
  cartManager:null,
  draftManager:null,
  optionManager:null,
  orderHistoryManager:null,
  acrylicTicketCouponManager:null,
  campaignManager:null,
  saleProductManager: null,
  productPriceManager:null,

  isCenterViewScroll: true,
  products: [], // TODO:いらない？
  currentProduct: null, // TODO:カート追加後にリセットする
  currentCanvasData: null,
  currentToolItem: ToolButtonType.select,
  layerVue: null,
  isLoading: false,
  userHistoryList: [],
  isAlertDialog: false,
  isCartInAlertDialog: false,
  cartInAlertDialogCallback: null,
  alertMessage: "",
  alertCallback: null,
  isShowPcAccessDialog: false,
  pcAccessDialogCallback: null,
  isLoadingMessage:false,
  isLoadingMessageFree:"",
  progress:0,
  estimatesProcess: null,
  isShowProgress:false,
  progressMessages:[],
  sendBytes:0,
  isShowYesNoDialog:false,
  yesNoDialogMessage:"",
  yesNoDialogCallback:null,
  mainCanvas:null,
  isShowEstimates:false,
  estimatesData:null,
  estimatesProductData:null,
  designImageFile: null,      // 現在編集中のものは全てファイルを保持しておく
  cutlineImageFile: null,
  scCutlineImageFile: null,
  frameCutlineImageFile: null, // TODO:いらんかも
  designImageURL: null,       // Uploadから他のビューへの受け渡し用
  cutlineImageURL: null,      // Uploadから他のビューへの受け渡し用
  scCutlineImageURL: null,       // シェアコードで入稿されたカットライン
  frameCutlineImageURL: null,  // シェアコードカットラインを表示用に枠線化したもの
  isShareCodeDraft: false,
  centerViewState: 6,
  previousCenterViewState: 6,
  rightViewState: 1,
  selectProductId: 0,
  isListEditMode: false,
  selectBackgroundColor:1,  // プレビュー時のカラー
  selectCutlineColor:0,     // プレビュー時のカラー
  isSignature:false,        // 署名済みかどうか
  shippingScreenType:"User",
  editShippingData:null,
  isShowReOrderOption:false,
  reorderOptionCallback:null,
  isShowReOrderDesign:false,
  reorderDesignCallback:null,
  reeditDesignCallback:null,
  isShowAddCartDialog:false,
  addCartDialogCallback:null,
  currentSelectPlateNo:0,   // 編集画面で現在選択中のプレートナンバー
  selectDraftDesign:null,
  isShowInputText:false,
  inputTextProp:null,
  isImagePopup:false,
  imagePopupImage:null,
  cardPayment:
  {
    isShow: false,
    prop: null,
    callback: null
  },

  isShowListPreview:false,
  isShowCart:false,
  isShowRightMenu:false,
  resetCameraFunc:null,
  isShowImagePreview:false,
  isShowImagesPreview:false,
  previewImageArray:[],
  isResendContractDialog: false,
  isLogout: false,
  tutorial:
  {
    isFirst: false,
    isShowBG: false,
    isShowPreview:false,
    previewStep:1,
    previewTutorialScroll:0,
    isShowShareCode:false,
    isShowEdit:false,
    editStep:1,
  },
  eventCreateData:
  {
    docId:"", // FirebaseのDocId（上書きに必要）
    eventName:"",
    eventIssuerName:"",
    selectSize:"S",
    userEdit:true,
    designData:null,
    cutlineData:null,
    frameCutlineImageURL:null,  // svgは画像化しておく
    nonEditableData:null,
    bannerData1:null,
    bannerData2:null,
    previewData:null,
    isEdit:null,  // 作成か編集かのフラグ
    folderName:"",  // アップロード先のフォルダー名
    isShippingFee: false, // チケット使用時に送料が存在するか
  },
  centerViewRef:null, // CenterViewの参照 スクロールの制御に使用
})
export default new Vuex.Store({
  state: initialState(),
  mutations: {
    setIsCenterViewScroll(state, isScroll){
      state.isCenterViewScroll = isScroll;
    },
    resetData(state) {
      Object.assign(state, initialState())
    },
    addProduct(state, product) {
      this.state.products.push(product);
      this.state.currentProduct = product;
    },
    removeProduct: function (state, product) {
      if (product === this.state.currentProduct) {
        this.state.currentProduct = null
        this.state.currentCanvasData = null
      }
      this.state.products = this.state.products.filter(function (a) {
        return a !== product;
      });
    },
    removeCurrentProductCanvasItem(state, item) {
      this.state.currentCanvasData.itemList = this.state.currentCanvasData.itemList.filter(function (a) {
        return a !== item;
      });
    },
    downCurrentProductCanvasItem(state, item) {
      let index = this.state.currentCanvasData.itemList.indexOf(item)
      if (index <= 0) {
        return
      }
      this.state.currentCanvasData.itemList.splice(index - 1, 0, item)
      this.state.currentCanvasData.itemList.splice(index + 1, 1)

    },
    upCurrentProductCanvasItem(state, item) {
      let index = this.state.currentCanvasData.itemList.indexOf(item)
      this.state.currentCanvasData.itemList.splice(index + 2, 0, item)
      this.state.currentCanvasData.itemList.splice(index, 1)

    },
    selectProduct(state, product) {
      state.currentProduct = product;
    },
    selectCanvasData(state, canvasData) {
      state.currentCanvasData = canvasData;
    },
    showLoading(state,item = false) {
      state.isLoading = true;
      state.isLoadingMessage = item
    },
    showLoadingMessage(state,message){
      state.isLoading = true;
      state.isLoadingMessageFree = message
    },
    updateLoadingMessage(state,message){
      state.isLoadingMessageFree = message
    },
    hideLoading(state) {
      state.isLoading = false;
      state.isLoadingMessage = false
      state.isLoadingMessageFree = ""
    },
    setAlertDialogCallback(state, callback){
      state.alertCallback = callback;
    },
    showMessage(state, message) {
      state.isAlertDialog = true;
      state.alertMessage = message
    },
    hideMessage(state) {
      state.isAlertDialog = false;
      state.alertCallback = null;
      state.alertMessage = ""
    },
    showPcAccessDialog(state, callback) {
      state.isShowPcAccessDialog = true;
      state.pcAccessDialogCallback = callback || null;
    },
    hidePcAccessDialog(state) {
      state.isShowPcAccessDialog = false;
      state.pcAccessDialogCallback = null;
    },
    showCartInDialog(state, callback) {
      state.isCartInAlertDialog = true;
      state.cartInAlertDialogCallback = callback;
    },
    hideCartInDialog(state) {
      state.isCartInAlertDialog = false;
      state.cartInAlertDialogCallback = null;
    },
    setCurrentToolItem(state, item) {
      state.currentToolItem = item;
    },
    setLayerVue(state, item) {
      state.layerVue = item
    },
    setUserHistoryData(state, item) {
      state.userHistoryList = item
    },
    setSaleProductManager(state, item) {
      state.saleProductManager = item
    },
    setEstimatesProcess(state, item) {
      state.estimatesProcess = item
    },
    // resetCart(state) {
    //   state.currentCanvasData = null
    //   this.state.products = []
    //   this.state.currentProduct = null
    // },
    setProgress(state,item){
      state.progress = item
    },
    setProgressMessages(state,item){
      state.progressMessages = item
    },
    showProgress(state){
      state.isShowProgress = true
    },
    hideProgress(state){
      state.isShowProgress = false
      state.progress = 0
      state.progressMessages = []
    },
    setSendBytes(state,item){
      state.sendBytes = item
    },
    showYesNoDialog(state,message){
      state.isShowYesNoDialog = true
      state.yesNoDialogMessage = message
    },
    setYesNoDialogCallback(state,callback){
      state.yesNoDialogCallback = callback
    },
    hideYesNoDialog(state){
      state.isShowYesNoDialog = false
      state.yesNoDialogMessage = ""
      state.yesNoDialogCallback = null
    },
    setMainCanvas(state,item){
      state.mainCanvas = item
    },
    showEstimates(state,data){
      state.isShowEstimates = true
      state.estimatesData = data
    },
    hideEstimates(state){
      state.isShowEstimates = false
      state.estimatesData = null
      state.estimatesProductData = null
    },
    setEstimatesProductData(state,item){
      state.estimatesProductData = item
    },
    setDesignImageFile(state, file){
      state.designImageFile = file;
    },
    setCutlineImageFile(state, file){
      state.cutlineImageFile = file;
    },
    setScCutlineImageFile(state, file){
      state.scCutlineImageFile = file;
    },
    setFrameCutlineImageFile(state, file){
      state.frameCutlineImageFile = file;
    },
    setDesignImageURL(state, url){
      state.designImageURL = url;
    },
    setCutlineImageURL(state, url){
      state.cutlineImageURL = url;
    },
    setScCutlineImageURL(state, url){
      state.scCutlineImageURL = url;
    },
    setFrameCutlineImageURL(state, url){
      state.frameCutlineImageURL = url;
    },
    setIsShareCodeDraft( state, isShareCode ){
      state.isShareCodeDraft = isShareCode;
    },
    setCenterViewState(state, viewState){
      state.previousCenterViewState = state.centerViewState;
      state.centerViewState = viewState;
      SetCenterViewUrl(state.centerViewState);
    },
    setPreviousCenterViewState(state){
      state.centerViewState = state.previousCenterViewState;
      SetCenterViewUrl(state.centerViewState);
    },
    setRightViewState(state, viewState){
      state.rightViewState = viewState;
    },
    setSelectProductId(state, id){
      state.selectProductId = id;
    },
    setListEditMode(state, isListEdit){
      state.isListEditMode = isListEdit;
    },
    setCartManager(state, item) {
      state.cartManager = item
    },
    setDraftManager(state, item) {
      state.draftManager = item
    },
    setSelectBackgroundColor(state, id){
      state.selectBackgroundColor = id;
    },
    setSelectCutlineColor(state, id){
      state.selectCutlineColor = id;
    },
    setIsSignature(state, f){
      state.isSignature = f;
    },
    setOptionManager(state, item) {
      state.optionManager = item
    },
    setOrderHistoryManager(state, item) {
      state.orderHistoryManager = item
    },
    setAcrylicTicketCouponManager(state, item) {
      state.acrylicTicketCouponManager = item
    },
    setCampaignManager(state, item) {
      state.campaignManager = item
    },
    setProductPriceManager(state, item) {
      state.productPriceManager = item
    },
    setShippingScreenType(state, item) {
      state.shippingScreenType = item
    },
    setEditShippingData(state, item) {
      state.editShippingData = item
    },
    setReorderOption(state,item) {
      state.isShowReOrderOption = item
    },
    setReorderOptionCallback(state,callback){
      state.reorderOptionCallback = callback
    },
    setReorderDesign(state,item) {
      state.isShowReOrderDesign = item
    },
    setReorderDesignCallback(state,{reorder, reedit}){
      state.reorderDesignCallback = reorder
      state.reeditDesignCallback = reedit
    },
    setAddCartDialog(state, {isShow, callback}) {
      state.isShowAddCartDialog = isShow
      state.addCartDialogCallback = callback
    },
    setCurrentSelectPlateNo(state, no){
      state.currentSelectPlateNo = no;
    },
    setSelectDraftDesign(state, design){
      state.selectDraftDesign = design
    },
    showInputText(state,prop) {
      state.isShowInputText = true;
      state.inputTextProp = prop
    },
    hideInputText(state) {
      state.inputTextProp = null
      state.isShowInputText = false;
    },
    showImagePopup(state,image){
      state.isImagePopup = true
      state.imagePopupImage = image
    },
    hideImagePopup(state) {
      state.isImagePopup = false
    },
    setCardPaymentCallback( state, callback ){
      state.cardPayment.callback = callback;
    },
    showCardPayment(state,cardPaymentProp){
      state.cardPayment.isShow = true
      state.cardPayment.prop = cardPaymentProp
    },
    hideCardPayment(state) {
      state.cardPayment.isShow = false
      state.cardPayment.callback = null;
      state.cardPayment.prop = null
    },
    showListPreview(state){
      state.isShowListPreview = true
    },
    hideListPreview(state){
      state.isShowListPreview = false
    },
    switchShowCart(state) {
      state.isShowCart = !state.isShowCart
    },
    showRightMenu(state) {
      state.isShowRightMenu = true;
    },
    hideRightMenu(state) {
      state.isShowRightMenu = false;
    },
    setResetCameraFunc(state, func){
      state.resetCameraFunc = func;
    },
    showImagePreview(state,image){
      state.isShowImagePreview = true
      state.previewImageArray = [image]
    },
    hideImagePreview(state) {
      state.isShowImagePreview = false
      state.previewImageArray = null
    },
    showImagsPreview(state,images){
      state.isShowImagesPreview = true
      state.previewImageArray = images
    },
    hideImagesPreview(state) {
      state.isShowImagesPreview = false
      state.previewImageArray = null
    },
    setIsFirstTutorial(state, flag){
      state.tutorial.isFirst = flag
    },
    setPreviewTutorialScroll(state, scroll){
      state.tutorial.previewTutorialScroll = scroll
    },
    showPreviewTutorial(state, step = 1){
      state.tutorial.isShowBG = true
      state.tutorial.isShowPreview = true
      state.tutorial.previewStep = step
    },
    hidePreviewTutorial(state){
      state.tutorial.isShowBG = false
      state.tutorial.isShowPreview = false
    },
    previewTutorialNextStep(state){
      state.tutorial.previewStep += 1
    },
    showResendContractDialog(state){
      state.isResendContractDialog = true;
    },
    hideResendContractDialog(state){
      state.isResendContractDialog = false;
    },
    logout(state){
      state.isLogout = true;
    },
    showShareCodeTutorial(state){
      state.tutorial.isShowBG = true
      state.tutorial.isShowShareCode = true
    },
    hideShareCodeTutorial(state){
      state.tutorial.isShowBG = false
      state.tutorial.isShowShareCode = false
    },
    showEditTutorial(state, step = 1){
      state.tutorial.isShowBG = true
      state.tutorial.isShowEdit = true
      state.tutorial.editStep = step
    },
    hideEditTutorial(state){
      state.tutorial.isShowBG = false
      state.tutorial.isShowEdit = false
    },
    editTutorialNextStep(state){
      state.tutorial.editStep += 1
    },
    resetEventCreateData(state){
      state.eventCreateData =
      {
        docId:"", // FirebaseのDocId（上書きに必要）
        eventName:"",
        eventIssuerName:"",
        selectSize:"S",
        userEdit:true,
        designData:null,
        cutlineData:null,
        frameCutlineImageURL:null,
        nonEditableData:null,
        bannerData1:null,
        bannerData2:null,
        previewData:null,
        isEdit:false,
        folderName:"",
        isShippingFee: false,
      }
    },
    setEventCreateDocId(state, id){
      state.eventCreateData.docId = id;
    },
    setEventCreateEventName(state, name){
      state.eventCreateData.eventName = name;
    },
    setEventCreateEventIssuerName(state, name){
      state.eventCreateData.eventIssuerName = name;
    },
    setEventCreateEventSelectSize(state, size){
      state.eventCreateData.selectSize = size;
    },
    setEventCreateEventUserEdit(state, edit){
      state.eventCreateData.userEdit = edit;
    },
    setEventCreateDesignData(state, fileKit){
      state.eventCreateData.designData = fileKit;
    },
    setEventCreateCutlineData(state, fileKit){
      state.eventCreateData.cutlineData = fileKit;
    },
    setEventCreateCutlineImageURL(state, url){
      state.eventCreateData.frameCutlineImageURL = url;
    },
    setEventCreateNonEditableData(state, fileKit){
      state.eventCreateData.nonEditableData = fileKit;
    },
    setEventCreateBannerData1(state, fileKit){
      state.eventCreateData.bannerData1 = fileKit;
    },
    setEventCreateBannerData2(state, fileKit){
      state.eventCreateData.bannerData2 = fileKit;
    },
    setEventCreatePreviewData(state, fileKit){
      state.eventCreateData.previewData = fileKit;
    },
    setEventCreateEventIsEdit(state, isEdit){
      state.eventCreateData.isEdit = isEdit;
    },
    setEventCreateEventFolderName(state, name){
      state.eventCreateData.folderName = name;
    },
    setEventCreateEventIsShippingFee(state, shippingFee){
      state.eventCreateData.isShippingFee = shippingFee;
    },
    setCenterViewRef(state, ref){
      state.centerViewRef = ref;
    },
  },
  actions: {
  },
  modules: {
    acryPrint,
    firstTimeFree,
    behalfCreate,
    designPreview,
  }
})
